<template>
  <main class="wrapper_full">
    <HeaderSecond :type="$attrs.type" v-if="checkShowHeaderSecond" />
    <BreadCrumbs id="scrollBlock" v-if="!($route.name == 'linkProjectReportSign')" />
    <div v-if="$route.meta.search" class="container">
      <div class="search-wrap">
        <Search routeQuery/>
      </div>
    </div>
    <transition name="slide-fade" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </main>
</template>

<script>
import HeaderSecond from 'components/HeaderSecond'
import BreadCrumbs from 'components/BreadCrumbs'
import Search from 'components/Search'
export default {
  name: 'ViewsTemplateMain',
  components: {
    HeaderSecond,
    BreadCrumbs,
    Search,
  },
  data() {
    return {
      checkShowHeaderSecond: true,
    }
  },
  mounted() {
    this.onCheckShowHeaderSecond()
    if (this.$route.name !== 'linkProjectReportSign') {
      window.onscroll = function () {
        myFunction()
      }
      var scrollBlock = document.getElementById('scrollBlock')
      var sticky = scrollBlock.offsetTop
      function myFunction() {
        if (window.pageYOffset > sticky) {
          scrollBlock.nextElementSibling.style.marginTop = scrollBlock.offsetHeight + 'px'
          scrollBlock.classList.add('sticky')
        } else {
          scrollBlock.nextElementSibling.style.marginTop = null
          scrollBlock.classList.remove('sticky')
        }
      }
    }
  },
  watch: {
    '$route.name'() {
      this.onCheckShowHeaderSecond()
    },
  },
  methods: {
    onCheckShowHeaderSecond() {
      let result = true
      for (let route of this.$router.currentRoute.matched) {
        if (route.meta.headerSecondDisable === true) {
          result = false
          break
        }
      }
      this.checkShowHeaderSecond = result
    },
  },
}
</script>

<style lang="scss">
.sticky {
  position: fixed;
  // top: 0;
  width: 100%;
  z-index: 10;
  border-bottom: 1px solid rgb(179, 179, 179);
}
.wrapper_full {
  position: relative;
}
.wrapper_full,
.mainSection {
  height: 100%;
  display: flex;
  flex-direction: column;
  .container {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    .wrap {
      flex-grow: 1;
      display: flex;
      flex-direction: column;

      & > div {
        flex-grow: 0;
      }
      .plug {
        flex-grow: 1;
      }
    }
  }
  .wrapper_selling {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    div {
      flex-grow: 0;
    }
    .plug {
      flex-grow: 1;
    }
  }
  .search-wrap {
    display: flex;
    justify-content: flex-end;
    justify-items: flex-end;
  }
}
</style>
